import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  useEffect(() => {
    window.googleTranslateElementInit = () => {
      try {
        if (window.google && window.google.translate) {
          if (!document.querySelector('.goog-te-gadget')) {
            new window.google.translate.TranslateElement(
              {
                pageLanguage: 'en',
                includedLanguages: 'en,ar,fr,ru,sw,fa,uz,bn,am',
                layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                autoDisplay: false,
              },
              'google_translate_element'
            );
          }
        }
      } catch (error) {
        console.warn("Google Translate suppressed runtime warning:", error);
      }
    };

    const scriptId = 'google-translate-script';
    let scriptNode = document.getElementById(scriptId);

    if (!scriptNode) {
      scriptNode = document.createElement('script');
      scriptNode.id = scriptId;
      scriptNode.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      scriptNode.async = true;
      scriptNode.crossOrigin = "anonymous";
      document.body.appendChild(scriptNode);
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit();
    }
  }, []);

  return (
    <header className="top-header">
      <style>{`
        /* ULTRA-COMPACT MOBILE BASE STYLING */
        .top-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: left ;
          padding: 6px 10px; /* Minimal container spacing padding */
          gap: 4px;          /* Minimal element separation spacing */
          width: 100%;
          box-sizing: border-box;
          border-bottom: 1px solid #eaeaea;
          font-family: Arial, sans-serif;
          background-color: #ffffff;
          overflow: hidden;
        }

        .logo-section {
          display: flex;
          justify-content: center; 
          align-items: center;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }

        .brand-logo-container {
          display: flex;
          align-items: center;
          justify-content: center; 
          text-decoration: none;
          color: inherit;
          gap: 6px; /* Reduced graphic-to-text gap */
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }

        .logo-text-brand {
          display: flex;
          flex-direction: column;
          align-items: flex-start; 
          min-width: 0;
        }

        .header-right-desktop {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          transform: scale(0.85); /* Scales down Google Translate dropdown box UI slightly */
          transform-origin: center center;
          margin: -2px 0;         /* Offsets widget bounding box height expand */
        }

        .translate-widget-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          overflow: hidden; 
        }

        #google_translate_element {
          display: inline-block;
          max-width: 100%;
        }

        /* DESKTOP RESPONSIVE LAYER (992px and up) */
        @media (min-width: 992px) {
          .top-header {
            flex-direction: row;
            justify-content: space-between;
            padding: 8px 24px;
            gap: 20px;
          }

          .logo-section {
            width: auto;
            max-width: none;
            justify-content: flex-start;
          }

          .brand-logo-container {
            justify-content: flex-start;
            width: auto;
          }

          .header-right-desktop {
            width: auto;
            margin-left: auto;
            transform: scale(1); /* Restores normal widget sizing on desktop */
          }

          .translate-widget-wrapper {
            justify-content: flex-end;
          }
        }
      `}</style>

      {/* BRAND LOGO SECTION */}
      <div className="logo-section">
        <Link to="/" className="brand-logo-container">
          {/* Micro Logo Icon Element Group (Scaled down to 26px) */}
          <div className="logo-graphic-globe-emblem" style={{ position: 'relative', width: '26px', height: '26px', flexShrink: 0 }}>
            <div className="globe-circle-line" style={{ border: '1.5px solid #2e7d32', borderRadius: '50%', width: '100%', height: '100%', boxSizing: 'border-box', position: 'absolute' }}></div>
            <div className="globe-cross-shield" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <span className="red-medical-plus-mark" style={{ color: '#d32f2f', fontSize: '11px', fontWeight: 'bold' }}>✚</span>
            </div>
            <div className="green-arrow-path" style={{ position: 'absolute', bottom: '-2px', right: '-2px', color: '#2e7d32', fontSize: '7px' }}>▲</div>
          </div>
          
          {/* Micro Text Branding */}
          <div className="logo-text-brand">
            <div className="logo-title-row" style={{ fontSize: 'clamp(0.9rem, 4vw, 1.15rem)', lineHeight: '1.1', whiteSpace: 'nowrap' }}>
              <span className="bold-title" style={{ fontWeight: '700', color: '#004b87' }}>Medical</span>
              <span className="light-title" style={{ fontWeight: '300', marginLeft: '3px', color: '#444444' }}>Trip World</span>
            </div>
            <p className="logo-subtext" style={{ margin: '0', fontSize: 'clamp(0.58rem, 2.3vw, 0.68rem)', color: '#666666', whiteSpace: 'nowrap' }}>Your Trusted Pathway to Health</p>
          </div>
        </Link>
      </div>

      {/* 🌐 GOOGLE TRANSLATION DESK */}
      <div className="header-right-desktop">
        <div className="translate-widget-wrapper">
          <div id="google_translate_element"></div>
        </div>
      </div>
    </header>
  );
}

export default Header;